import { type FormEvent, useState } from 'react';
import { Navigate, useNavigate, useSearchParams } from 'react-router';
import { errorMessage, post } from '../api/client';
import type { User } from '../api/types';
import { safeNext, useMe, useSignedIn } from '../auth';
import { Field, LangSwitch } from '../components/ui';
import { useT } from '../i18n';
import { BRAND } from '../site';

export function Login() {
  const { t } = useT();
  const me = useMe();
  const signedIn = useSignedIn();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const next = safeNext(params.get('next'));

  if (me.data) return <Navigate to={next} replace />;

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const { user } = await post<{ user: User }>('/admin/auth/login', { email, password });
      signedIn(user);
      navigate(next, { replace: true });
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="center">
      <form className="panel login" onSubmit={submit}>
        <img src="/logo.svg" alt={BRAND.name} className="logo" />
        <div style={{ textAlign: 'center' }}>
          <p className="kicker" style={{ marginBottom: 6 }}>
            {t('Dashboard')}
          </p>
          <p className="muted" style={{ margin: 0 }}>
            {t(BRAND.tagline)}
          </p>
        </div>
        {error && <div className="notice error">{error}</div>}
        <Field label={t('Correo')}>
          {(id) => <input id={id} className="input" type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} />}
        </Field>
        <Field label={t('Contraseña')}>
          {(id) => (
            <input id={id} className="input" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} />
          )}
        </Field>
        <button className="btn btn-primary btn-block" disabled={busy}>
          {busy ? t('Entrando…') : t('Entrar')}
        </button>
        <LangSwitch />
      </form>
    </div>
  );
}
